import moment from "moment";
import { createContext, useContext, useState } from "react";

export const DashboardCardContext = createContext()

export function DashboardCardProvider({ children }) {
  // APROVADOS
  const [dateCardAprovatedFrom, setDateCardAprovatedFrom] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [dateCardAprovatedTo, setDateCardAprovatedTo] = useState(moment().format('YYYY-MM-DD'));

  // REPROVADOS
  const [dateCardReprovatedFrom, setDateCardReprovatedFrom] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [dateCardReprovatedTo, setDateCardReprovatedTo] = useState(moment().format('YYYY-MM-DD'));

  // AGUARDANDO ASSINATURA
  const [dateCardWaitingSignatureFrom, setDateCardWaitingSignatureFrom] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [dateCardWaitingSignatureTo, setDateCardWaitingSignatureTo] = useState(moment().format('YYYY-MM-DD'));

  // TEMPO MÉDIO DE APROVAÇÃO
  const [dateCardAverageAproveFrom, setDateCardAverageAproveFrom] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [dateCardAverageAproveTo, setDateCardAverageAproveTo] = useState(moment().format('YYYY-MM-DD'));

  // TEMPO MÉDIO DE STATUS
  const [dateCardStatusAverageTimeFrom, setDateCardStatusAverageTimeFrom] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [dateCardStatusAverageTimeTo, setDateCardStatusAverageTimeTo] = useState(moment().format('YYYY-MM-DD'));

  return (
    <DashboardCardContext.Provider
      value={{
        dateCardAprovatedFrom,
        setDateCardAprovatedFrom,
        dateCardAprovatedTo,
        setDateCardAprovatedTo,
        dateCardReprovatedFrom,
        setDateCardReprovatedFrom,
        dateCardReprovatedTo,
        setDateCardReprovatedTo,
        dateCardWaitingSignatureFrom,
        setDateCardWaitingSignatureFrom,
        dateCardWaitingSignatureTo,
        setDateCardWaitingSignatureTo,
        dateCardAverageAproveFrom,
        setDateCardAverageAproveFrom,
        dateCardAverageAproveTo,
        setDateCardAverageAproveTo,
        dateCardStatusAverageTimeFrom,
        setDateCardStatusAverageTimeFrom,
        dateCardStatusAverageTimeTo,
        setDateCardStatusAverageTimeTo,
      }}
    >
      {children}
    </DashboardCardContext.Provider>
  )
}

export const useDashboardCardContext = () => {
  const {
    dateCardAprovatedFrom,
    setDateCardAprovatedFrom,
    dateCardAprovatedTo,
    setDateCardAprovatedTo,
    dateCardReprovatedFrom,
    setDateCardReprovatedFrom,
    dateCardReprovatedTo,
    setDateCardReprovatedTo,
    dateCardWaitingSignatureFrom,
    setDateCardWaitingSignatureFrom,
    dateCardWaitingSignatureTo,
    setDateCardWaitingSignatureTo,
    dateCardAverageAproveFrom,
    setDateCardAverageAproveFrom,
    dateCardAverageAproveTo,
    setDateCardAverageAproveTo,
    dateCardStatusAverageTimeFrom,
    setDateCardStatusAverageTimeFrom,
    dateCardStatusAverageTimeTo,
    setDateCardStatusAverageTimeTo,
  } = useContext(DashboardCardContext);

  return {
    dateCardAprovatedFrom,
    setDateCardAprovatedFrom,
    dateCardAprovatedTo,
    setDateCardAprovatedTo,
    dateCardReprovatedFrom,
    setDateCardReprovatedFrom,
    dateCardReprovatedTo,
    setDateCardReprovatedTo,
    dateCardWaitingSignatureFrom,
    setDateCardWaitingSignatureFrom,
    dateCardWaitingSignatureTo,
    setDateCardWaitingSignatureTo,
    dateCardAverageAproveFrom,
    setDateCardAverageAproveFrom,
    dateCardAverageAproveTo,
    setDateCardAverageAproveTo,
    dateCardStatusAverageTimeFrom,
    setDateCardStatusAverageTimeFrom,
    dateCardStatusAverageTimeTo,
    setDateCardStatusAverageTimeTo,
  }
};
